import { Component, Input } from '@angular/core';
import {ActivePack} from '../../interfaces/active-pack';

@Component({
  selector: 'app-active-packs',
  templateUrl: './active-packs.component.html',
  styleUrls: ['./active-packs.component.less'],
})
export class ActivePacksComponent {
  @Input() activePack?: ActivePack;
}
